import { render } from "./NCodeMetrics.vue?vue&type=template&id=6656b2f3&scoped=true&ts=true"
import script from "./NCodeMetrics.vue?vue&type=script&lang=ts"
export * from "./NCodeMetrics.vue?vue&type=script&lang=ts"

import "./NCodeMetrics.vue?vue&type=style&index=0&id=6656b2f3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6656b2f3"]])

export default __exports__